export default "__VITE_ASSET__89f90389__"